import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBarModule,
    MatSnackBarRef,
} from '@angular/material/snack-bar';
import {
    IconColor,
    IconComponent,
    IconName,
} from '@montebravo.tech/design-system-icons';

@Component({
    selector: 'app-snackbar',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatSnackBarModule, IconComponent],
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
})
export class SnackBarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA)
        public data: {
            message: string;
            icon: IconName;
            iconColor: IconColor;
        },
        private snackBarRef: MatSnackBarRef<SnackBarComponent>
    ) {}

    get message(): string {
        return this.data.message;
    }

    get icon(): IconName {
        return this.data.icon;
    }

    get iconColor(): IconColor {
        return this.data.iconColor;
    }

    public close() {
        this.snackBarRef.dismiss();
    }
}
